import { render } from "./stat5.vue?vue&type=template&id=a4fefa06"
import script from "./stat5.vue?vue&type=script&lang=js"
export * from "./stat5.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/oralhealthmap.uz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__